<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-form ref="form">
          <v-container class="py-0">
            <v-toolbar-title>{{$t('keywords.register') }}</v-toolbar-title>
            <v-row>
              <v-col cols='12' xs='12'>
                <v-switch
                  :label="$t('check.active')"
                  v-model='jobEnviaDadosWsDTO.active'
                  hide-details
                ></v-switch>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  :readonly="isUpdating"
                  :rules="alphaNumericRules(jobEnviaDadosWsDTO.jobIdentifier)"
                  name="jobIdentifier"
                  :label="$t('keywords.id')"
                  :hint="$t('jobenviadadosws.hint.id_db')"
                  v-model="jobEnviaDadosWsDTO.jobIdentifier"
                />
              </v-col>

              <v-col cols="12" md="4">
                <DatabaseSelect
                  :label="$t('keywords.db')"
                  name="listTenant"
                  :required="true"
                  v-model="jobEnviaDadosWsDTO.tenant"
                />
              </v-col>

              <v-col cols="12" md="4">
                <CronField v-model="jobEnviaDadosWsDTO.cronExpression" />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field
                  name="urlReintegrate"
                  :label="$t('jobenviadadosws.url')"
                  v-model="jobEnviaDadosWsDTO.urlReintegrate"
                />
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                  name="returnEncoding"
                  :label="$t('keywords.encoding')"
                  v-model="jobEnviaDadosWsDTO.returnEncoding"
                />
              </v-col>

              <v-col cols="12" sm="3" v-if="isPlatform">
                <RoutingkeySelect v-model="jobEnviaDadosWsDTO.routingkey" :rules="requiredRules(jobEnviaDadosWsDTO.routingkey)" />
              </v-col>

              <v-col cols="12" sm="2">
                <BeansConfiguration
                  v-model="jobEnviaDadosWsDTO"
                  AuthenticationClassType="br.com.senior.plutaoapp.utils.process.AuthenticationExecutor"
                  SearchDatabaseClassType="br.com.senior.plutaoapp.jobenviodadosrest.process.SearchDatabaseExecutor"
                  SqlUpdateBeforeWsCallClassType="br.com.senior.plutaoapp.jobenviodadosrest.process.SqlUpdateBeforeWsCallExecutor"
                  SqlUpdateAfterWsCallSuccessClassType="br.com.senior.plutaoapp.jobenviodadosrest.process.SqlUpdateAfterWsCallSuccessExecutor"
                  SqlUpdateAfterWsCallErrorClassType="br.com.senior.plutaoapp.jobenviodadosrest.process.SqlUpdateAfterWsCallErrorExecutor"
                  WsCallClassType="br.com.senior.plutaoapp.jobenviodadosrest.process.WsCallExecutor"
                  ConvertDatabaseResultClassType="br.com.senior.plutaoapp.utils.process.ConvertDatabaseResultExecutor"
                />
              </v-col>
            </v-row>
            <v-expansion-panels v-model="panelsOpenned" multiple>
              <v-expansion-panel>
                <v-expansion-panel-header>{{$t('jobenviadadosws.sql_query')}}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row v-if="showQuery">
                    <v-col cols="12" md="6">
                      <SQLFormatter
                        name="sqlSearch"
                        :label="$t('jobenviadadosws.label.sql.query')"
                        :hint="$t('jobenviadadosws.hint.sql.query')"
                        :placeholder="`SELECT :${this.$t('jobenviadadosws.sql.employees')} AS resultado FROM dual`"
                        v-model="jobEnviaDadosWsDTO.sqlSearch"
                        v-bind:required="true"
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <SQLFormatter
                        name="sqlUpdateBeforeWsCall"
                        :label="$t('jobenviadadosws.label.sql.to_update')"
                        placeholder="UPDATE tabela SET campo = 'N' WHERE outro_campo = 'A'"
                        v-model="jobEnviaDadosWsDTO.sqlUpdateBeforeWsCall"
                      />
                    </v-col>
                  </v-row>
                  <v-row v-if="showQuery">
                    <v-col cols="12" md="6">
                      <SQLFormatter
                        name="sqlUpdateAfterWsCallSuccess"
                        :label="$t('jobenviadadosws.label.sql.update.success')"
                        :placeholder="`UPDATE ${this.$t('jobenviadadosws.sql.table')} SET ${this.$t('jobenviadadosws.sql.field')} = '${this.$t('jobenviadadosws.sql.success')}' WHERE ${this.$t('jobenviadadosws.sql.other_field')} = '${this.$t('jobenviadadosws.sql.integrated')}'`"
                        v-model="jobEnviaDadosWsDTO.sqlUpdateAfterWsCallSuccess"
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <SQLFormatter
                        name="sqlUpdateAfterWsCallError"
                        :label="$t('jobenviadadosws.label.sql.update.error')"
                        :placeholder="`UPDATE tabela SET ${this.$t('jobenviadadosws.sql.field')} = '${this.$t('jobenviadadosws.sql.error')}' WHERE ${this.$t('jobenviadadosws.sql.other_field')} = '${this.$t('jobenviadadosws.sql.not_integrated')}'`"
                        v-model="jobEnviaDadosWsDTO.sqlUpdateAfterWsCallError"
                      />
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>{{$t('keywords.authorization')}}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field
                        name="wsUrl"
                        label="WS URL"
                        v-model="jobEnviaDadosWsDTO.wsUrl"
                        :rules="requiredRules(jobEnviaDadosWsDTO.wsUrl)"
                      />
                    </v-col>
                    <v-col cols="12" md="2">
                      <HttpMethodSelect
                        :label="$t('keywords.ws_method')"
                        :hide-get="true"
                        v-model="jobEnviaDadosWsDTO.wsMethod"
                        :required="true"
                      />
                    </v-col>
                    <v-col cols="12" md="4">
                      <AuthenticationSelect v-model="jobEnviaDadosWsDTO.wsAuthenticationType" :rules="requiredRules(jobEnviaDadosWsDTO.wsAuthenticationType)" />
                    </v-col>
                  </v-row>
                  <v-row v-if="jobEnviaDadosWsDTO.wsAuthenticationType == 'Bearer'">
                    <v-col cols="12">
                      <v-text-field
                        name="wsAuthenticationToken"
                        label="WS Token"
                        v-model="jobEnviaDadosWsDTO.wsAuthenticationToken"
                      />
                    </v-col>
                  </v-row>
                  <v-row v-else-if="jobEnviaDadosWsDTO.wsAuthenticationType == 'Basic'">
                    <v-col cols="12">
                      <CredentialSelect
                        name="wsAuthenticationCredentialName"
                        :label="$t('keywords.authentication.credential')"
                        v-model="jobEnviaDadosWsDTO.wsAuthenticationCredentialName"
                        type="AUTHENTICATION_WS"
                        :required="true"
                      />
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-container>
        </v-form>
      </v-col>
    </v-row>
    <v-row class="mt-5 pt-5">
      <v-col cols="12" class="text-right">
        <v-btn color="success" class="mr-0" @click="saveItem">{{ $t('button.save') }}</v-btn>
        <v-btn color="blue darken-1" text @click="close">{{ $t('button.cancel') }}</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
/* eslint-disable */
import JobEnviaDadosWs from '@/services/JobEnviaDadosWsRest'
import HttpMethodSelect from '../core/HttpMethodSelect'
import DatabaseSelect from '../core/DatabaseSelect'
import CredentialSelect from '../core/CredentialSelect'
import cronExpression from '../../utils/CronExpression'
import SQLFormatter from '../core/SQLFormatter'
import LocalStorageService from '../../services/LocalStorageService'
import BeansConfiguration from '../core/BeansConfiguration.vue'
import AuthenticationSelect from '../core/AuthenticationSelect.vue'
import { alphaNumericRules, requiredRules } from '../../utils/rules'
import RoutingkeySelect from '../core/RoutingkeySelect.vue'
import CronField from '../core/CronField'

export default {
  name: 'jobEnviaDadosWsRestForm',

  components: {
    DatabaseSelect,
    SQLFormatter,
    CredentialSelect,
    HttpMethodSelect,
    BeansConfiguration,
    AuthenticationSelect,
    RoutingkeySelect,
    CronField
  },

  props: {
    tenantUpdating: String
  },

  computed: {
    isPlatform () { return LocalStorageService.isPlatform() }
  },

  data: () => ({
    alphaNumericRules,
    requiredRules,
    jobEnviaDadosWsDTO: {
      jobIdentifier: '',
      routingkey: '',
      sqlSearch: '',
      sqlUpdateBeforeWsCall: '',
      urlReintegrate: '',
      wsUrl: '',
      wsMethod: '',
      wsAuthenticationType: '',
      wsAuthenticationToken: '',
      wsAuthenticationCredentialName: '',
      wsAuthenticationBean: '',
      sqlUpdateAfterWsCallSuccess: '',
      sqlUpdateAfterWsCallError: '',
      cronExpression: '',
      searchDataBaseExecutorBean: '',
      sqlUpdateAfterWsCallSuccessExecutorBean: '',
      sqlUpdateAfterWsCallErrorExecutorBean: '',
      sqlUpdateBeforeWsCallExecutorBean: '',
      wsCallExecutorBean: '',
      convertDatabaseResultExecutorBean: '',
      active: true,
      tenant: '',
      returnEncoding: 'UTF-8',
      clientPrefix: ''
    },
    showQuery: false,
    isUpdating: false,
    cronExpressionResult: '',
    alertShow: false,
    alertType: 'info',
    panelsOpenned: [0]
  }),

  created () {
    this.loadDB()
  },

  methods: {
    loadDB () {
      if (this.tenantUpdating) {
        JobEnviaDadosWs.findById(this.tenantUpdating)
          .then(response => {
            this.isUpdating = true
            this.jobEnviaDadosWsDTO = response.data
          })
          .catch(error => this.$message.error(`${this.$t('warnings.error.occurred')} : ${error}`))
          .finally(() => { this.showQuery = true })
      } else {
        this.showQuery = true
      }
    },

    async saveItem () {
      this.jobEnviaDadosWsDTO.lastModifiedBy = LocalStorageService.getUsername()
      this.jobEnviaDadosWsDTO.clientPrefix = LocalStorageService.getClientPrefix()

      /*
      if (this.isUpdating) {
        const responseWS = await JobEnviaDadosWs.findById(this.tenantUpdating)
        this.jobEnviaDadosWsDTO.routingkey = responseWS.data.routingkey
      }
      */

      this.verifyCronExpression().then((res) => {
        if (res) {
          if (this.$refs.form.validate()) {
            if (this.isUpdating) this.updateItem()
            else this.createItem()
          } else {
            this.$message.error(this.$t('warnings.validation.fill_required_fields'))
          }
        } else {
          this.$message.error(this.$t('warnings.incorrect_cron'))
        }
      })
    },

    async verifyCronExpression () {
      if (this.jobEnviaDadosWsDTO.cronExpression) {
        let cronValid = false
        const result = await cronExpression(this.jobEnviaDadosWsDTO.cronExpression)

        if (result?.data?.description) {
          this.cronExpressionResult = result.data.description
          cronValid = true
        } else {
          this.cronExpressionResult = result.data.error
        }

        return cronValid
      }
    },

    createItem () {
      JobEnviaDadosWs.insert(this.jobEnviaDadosWsDTO)
        .then(() => this.$emit('editItem', true, null))
        .catch(error => this.$message.error(`${this.$t('warnings.error.insert')} : ${error}`))
    },

    updateItem () {
      JobEnviaDadosWs.update(this.jobEnviaDadosWsDTO)
        .then(() => this.$emit('editItem', true, null))
        .catch(error => this.$message.error(`${this.$t('warnings.error.update')} : ${error}`))
    },

    close () {
      this.$emit('editItem', true, null)
    }
  }
}
</script>
